import type { TrackableProduct } from 'types/TrackableProduct';

import type { User } from '~/root';
import algolia from '~/services/algolia.client';
import gtm from '~/services/gtm.client';

import UserEvent from './UserEvent';

type EventData = {
  buttonName: string;
  isBot: boolean;
  pagePosition: string;
  product: TrackableProduct;
  user: User;
};

class ClickSaveProductEvent extends UserEvent<EventData> {
  private getQueryID() {
    return this.data.product.queryID;
  }

  private getProductId() {
    return this.data.product.product_id;
  }

  sendToGtm() {
    if (!this.data.user.isLoggedIn) {
      gtm.pushToDataLayer({
        button_name: this.data.buttonName,
        event: 'register_intent',
        page_position: this.data.pagePosition
      });
    }
  }

  sendToAlgolia() {
    const queryID = this.getQueryID();

    if (queryID) {
      algolia.convertedObjectIdAfterSearch({
        eventName: 'Save Product Clicked',
        id: this.getProductId().toString(),
        queryID,
        user: this.data.user
      });
    }
  }
}

export default ClickSaveProductEvent;
